import dayjs from 'dayjs'
import { AddToCalendarData_content_EventContent } from 'globalTypes'

import googleCalendarIcon from './icons/google-calendar.svg'
import officeIcon from './icons/office365.svg'
import outlookIcon from './icons/outlook.svg'
import yahooIcon from './icons/yahoo.svg'

const getGoogleCalendarLink = (
  content: AddToCalendarData_content_EventContent
) => {
  const start = dayjs(content.start, 'YYYY-MM-DD HH:mm:ss')
  const end = dayjs(content.end, 'YYYY-MM-DD HH:mm:ss')

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${start.format(
    'YYYYMMDDTHHmmss[Z]'
  )}%2F${end.format('YYYYMMDDTHHmmss[Z]')}&details=${encodeURIComponent(
    content.description
  )}&location=${encodeURIComponent(
    content.location || content.url
  )}&text=${encodeURIComponent(content.title)}`
}

const getOfficeLink = (content: AddToCalendarData_content_EventContent) => {
  const start = dayjs(content.start, 'YYYY-MM-DD HH:mm:ss')
  const end = dayjs(content.end, 'YYYY-MM-DD HH:mm:ss')

  return `https://outlook.office.com/calendar/0/deeplink/compose?body=${encodeURIComponent(
    content.description
  )}&enddt=${encodeURIComponent(
    end.format('YYYY-MM-DDTHH:mm:ssZ')
  )}&location=${encodeURIComponent(
    content.location || content.url
  )}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${encodeURIComponent(
    start.format('YYYY-MM-DDTHH:mm:ssZ')
  )}&subject=${encodeURIComponent(content.title)}`
}
const getOutlookLink = (content: AddToCalendarData_content_EventContent) => {
  const start = dayjs(content.start, 'YYYY-MM-DD HH:mm:ss')
  const end = dayjs(content.end, 'YYYY-MM-DD HH:mm:ss')

  return `https://outlook.live.com/calendar/0/deeplink/compose?body=${encodeURIComponent(
    content.description
  )}&enddt=${encodeURIComponent(
    end.format('YYYY-MM-DDTHH:mm:ssZ')
  )}&location=${encodeURIComponent(
    content.location || content.url
  )}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${encodeURIComponent(
    start.format('YYYY-MM-DDTHH:mm:ssZ')
  )}&subject=${encodeURIComponent(content.title)}`
}
const getYahooLink = (content: AddToCalendarData_content_EventContent) => {
  const start = dayjs(content.start, 'YYYY-MM-DD HH:mm:ss')
  const end = dayjs(content.end, 'YYYY-MM-DD HH:mm:ss')

  return `https://calendar.yahoo.com/?desc=${encodeURIComponent(
    content.description
  )}&et=${encodeURIComponent(
    end.format('YYYY-MM-DDTHH:mm:ssZ')
  )}&in_loc=${encodeURIComponent(
    content.location || content.url
  )}&st=${start.format('YYYYMMDDTHHmmss[Z]')}&title=${encodeURIComponent(
    content.title
  )}&v=60`
}

export const getCalendars = (
  content: AddToCalendarData_content_EventContent
) => ({
  'Google Calendar': {
    icon: googleCalendarIcon.src,
    link: getGoogleCalendarLink(content),
  },
  'Office 365': {
    icon: officeIcon.src,
    link: getOfficeLink(content),
  },
  Outlook: {
    icon: outlookIcon.src,
    link: getOutlookLink(content),
  },
  Yahoo: {
    icon: yahooIcon.src,
    link: getYahooLink(content),
  },
})
